import { takeEvery, put, call } from 'redux-saga/effects';
import flatten from 'flat';
import { fetchTranslationsSuccess, fetchTranslationsFailure, FETCH_TRANSLATIONS_REQUEST } from './actions';
import { setCurrentLocale, mergeTranslations } from './utils';
import * as defaultTranslations from './defaults';
export function createTranslationSaga({ getTranslation, translations }) {
    function* handleFetchTranslationsRequest(action) {
        try {
            const { locale } = action.payload;
            let result;
            if (getTranslation) {
                result = yield call(() => getTranslation(locale));
            }
            else if (translations) {
                result = translations[locale];
            }
            else {
                throw new Error('You must provide `translations` or `getTranslations`');
            }
            // merge translations and defaults
            const allTransalations = mergeTranslations(flatten(defaultTranslations[locale]), flatten(result));
            setCurrentLocale(locale, allTransalations);
            yield put(fetchTranslationsSuccess(locale, allTransalations));
        }
        catch (error) {
            yield put(fetchTranslationsFailure(error.message));
        }
    }
    return function* translationSaga() {
        yield takeEvery(FETCH_TRANSLATIONS_REQUEST, handleFetchTranslationsRequest);
    };
}
//# sourceMappingURL=sagas.js.map